import React from 'react';
import { Recording } from '../../queries/recordings/types';
import { AtsAsset } from '../ATS/ats-asset';
import Badge from '../Badge';
import { HorizontalAsset } from './HorizontalAsset';
import { usePvrAsset } from './use-pvr-asset';

interface PvrAssetProps {
  group: Recording.Group.Union;
  showProgress?: boolean;
  playOnHover?: boolean;
  showChannel?: boolean;
}

export function PvrAsset({ group, showProgress, playOnHover, showChannel = true }: PvrAssetProps) {
  const asset = usePvrAsset(group, showProgress, playOnHover);

  if (!asset) {
    return null;
  }

  return (
    <AtsAsset
      to={asset.link}
      title={asset.title.join(' - ')}
      subtitle={asset.subtitle}
      image={asset.image}
      badge={asset.badge ? <Badge {...asset.badge} /> : undefined}
      progress={asset.progress}
      providers={showChannel && group.channel ? [group.channel.contentId] : undefined}
      pattern="wide"
    />
  );
}

export function PvrAssetSeeAll({ to }: { to: string }) {
  return <HorizontalAsset isSeeAll link={to} />;
}

export function PvrAssetSkeleton() {
  return <AtsAsset.Skeleton pattern="wide" />;
}
